<div
  class="notification-banner"
  [class.borderless]="borderless()"
  [ngClass]="type()">
  @if (showTypeIcon()) {
    <topo-icon [props]="iconProps()" />
  }

  <div class="content">
    <ng-content />
  </div>

  @if (closeable()) {
    <topo-close
      size="small"
      (onClick)="onClose.emit()" />
  }
</div>
